import gql from 'graphql-tag';
import { useQuery as defaultUseQuery } from '@apollo/react-hooks';

import {
  ApolloInjection,
  CurrenciesQuery,
  Currency,
} from '@zapier/upsells/src/types';

export const currenciesQuery = gql`
  query upsells_currenciesQuery {
    currencies {
      icon
      id
      multiplier
      name
      symbol
      zeroDecimal
    }
  }
`;

export const useCurrencies = (props?: ApolloInjection) => {
  const useQuery = props?.useQuery || defaultUseQuery;
  const { client, data, error, loading } = useQuery<CurrenciesQuery>(
    currenciesQuery
  );

  return {
    currencies: data?.currencies || [],
    error: error?.message,
    isLoading: loading,
    onSelectCurrency: (currency: Currency) =>
      client.writeData({
        data: { selectedCurrency: currency },
      }),
  };
};
